{
    "Accessibility menu": "アクセシビリティメニュー",
    "Reset settings": "設定をリセット",
    "Close": "閉じる",
    "Content adjustments": "コンテンツ調整",
    "Navigation adjustments": "ナビゲーション調整",
    "Align Left": "左揃え",
    "Adjust Font Size": "フォントサイズ調整",
    "Highlight Title": "タイトルを強調",
    "Highlight Links": "リンクを強調",
    "Readable Font": "読みやすいフォント",
    "Colour adjustments": "色調整",
    "Dark Contrast": "暗いコントラスト",
    "Light Contrast": "明るいコントラスト",
    "High Contrast": "高コントラスト",
    "High Saturation": "高彩度",
    "Low Saturation": "低彩度",
    "Monochrome": "モノクロ",
    "Tools": "ツール",
    "Reading Guide": "リーディングガイド",
    "Stop Animations": "アニメーション停止",
    "Big Cursor": "大きなカーソル",
    "Increase Font Size": "フォントサイズ拡大",
    "Decrease Font Size": "フォントサイズ縮小",
    "Letter Spacing": "文字間隔",
    "Line Height": "行の高さ",
    "Font Weight": "フォントの太さ",
    "Dyslexia Font": "ディスレクシア用フォント",
    "Language": "言語",
    "Accessibility widget": "アクセシビリティメニューを開く",
    "Accessibility Profiles": "アクセシビリティプロファイル",
    "Cognitive Disability": "認知障害",
    "Seizure Safe": "発作安全",
    "Accessibility statement": "アクセシビリティステートメント"
}